export default __webpack_public_path__ + "static/media/8.27d68e13.jpg";